import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TextMaskModule } from 'angular2-text-mask';
import { CepPipe } from 'app/core/pipes/cep.pipe';
import { CpfCnpjPipe } from 'app/core/pipes/cpf-cnpj.pipe';
import { PhonePipe } from 'app/core/pipes/phone.pipe';
import { PlacaPipe } from 'app/core/pipes/placa.pipe';
import { ModalService } from 'app/services/modal.service';
import { DialogFactory } from 'utils/DialogFactory';
import { InputNormalizeDirective } from 'utils/InputNormalizeDirective';
import { AutoCompleteCidadeComponent } from './components/auto-complete-cidade/auto-complete-cidade.component';
import { AutoCompleteMarcaModeloComponent } from './components/auto-complete-marca-modelo/auto-complete-marca-modelo.component';
import { AlertDialog, BottomSheetDialog, ConfirmDialog } from './components/dialog/dialog.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { LoaderComponent } from './loader/loader.component';

const pipes = [CepPipe, CpfCnpjPipe, PhonePipe, PlacaPipe]

@NgModule({
    declarations: [
        LoaderComponent, 
        PageHeaderComponent, 
        AutoCompleteCidadeComponent, 
        AutoCompleteMarcaModeloComponent, 
        AlertDialog, 
        ConfirmDialog, 
        BottomSheetDialog, 
        InputNormalizeDirective,
        ...pipes
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        FlexLayoutModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDatepickerModule,
        MatDividerModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatIconModule,
        MatSelectModule,
        MatSnackBarModule,
        MatGridListModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatDialogModule,
        MatToolbarModule,
        TextMaskModule,
        MatBottomSheetModule,
    ],
    exports: [
        AutoCompleteCidadeComponent,
        AutoCompleteMarcaModeloComponent,
        LoaderComponent,
        PageHeaderComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        FlexLayoutModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDatepickerModule,
        MatDividerModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatIconModule,
        MatSelectModule,
        MatSnackBarModule,
        MatGridListModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatToolbarModule,
        TextMaskModule,
        MatBottomSheetModule,
        InputNormalizeDirective,
        ...pipes
    ],
    providers: [
        ModalService,
        DialogFactory
    ],
})
export class SharedModule {}
